// Upload up to N images to Cloudinary via the signed endpoint. Returns array of secure URLs.
export async function uploadImages(files, folder) {
  const sigRes = await fetch("/api/cloudinary-sign", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ folder }),
  });
  const sig = await sigRes.json();
  if (sig.error) throw new Error(sig.error);

  const urls = [];
  for (const file of files) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("api_key", sig.apiKey);
    fd.append("timestamp", sig.timestamp);
    fd.append("signature", sig.signature);
    fd.append("folder", sig.folder);
    fd.append("transformation", sig.transformation);
    const res = await fetch(`https://api.cloudinary.com/v1_1/${sig.cloudName}/image/upload`, { method: "POST", body: fd });
    const data = await res.json();
    if (data.secure_url) urls.push(data.secure_url);
  }
  return urls;
}
